import React from 'react';
import API from "../base/API";
import moment from "moment";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import { translate } from "../base/Translation";

export default class NotificationList extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_notifications: "/notification/fetch/all?limit_from=:from&limit_max=:to",
        });

        this.state = {
            limit_from: 0,
            limit_to: 99999,
            notifications: [],
            tableData: [],
            tableColumns: [
                { name: "user", display: translate("Používateľ"), sort: true, width: 20 },
                { name: "action", display: translate("Akcia"), sort: true, width: 20 },
                { name: "content", display: translate("Obsah"), sort: true, width: 50 },
                { name: "date", display: translate("Dátum"), sort: true, width: 10 },
            ]
        };
    }

    fetchData() {
        this.api.request({
            cache: true,
            route: "get_notifications",
            params: { from: this.state.limit_from, to: this.state.limit_to },
            success: (response) => {
                let tableData = this.convertDataForTable(response);
                this.setState({ notifications: response, tableData });
            }
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    convertDataForTable(data) {
        return data.map(function (notification) {
            let data = {};
            data.user = notification.user.name;
            data.content = notification.content;
            data.action = notification.action;
            data.date = moment(notification.created.date).format("D.M.Y H:m:s");
            return data;
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <SorTable per_page={50} columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="content" title={translate("Notifikácie")} right={() => {
                            // Return empty, since when "right" is not used page header is not shown.
                            return "";
                        }} />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/notification/NotificationList.js